import { jsx as t, jsxs as n } from "react/jsx-runtime";
import { Stack as h, Skeleton as r, Box as o } from "@mui/material";
const l = ({ type: i, length: e }) => {
  if (i === "listitems")
    return /* @__PURE__ */ t(a, { length: e || 4 });
  if (i === "listitemswithheading")
    return /* @__PURE__ */ n(h, { spacing: 2, children: [
      /* @__PURE__ */ t(r, { variant: "text", width: 100, sx: { fontSize: "2rem" } }),
      /* @__PURE__ */ t(a, { length: e || 4 })
    ] });
  if (i === "page")
    return /* @__PURE__ */ n(h, { spacing: 2, padding: 2, width: "100%", children: [
      /* @__PURE__ */ t(r, { variant: "rectangular", height: 50 }),
      /* @__PURE__ */ t(r, { variant: "text", width: 100, sx: { fontSize: "2rem" } }),
      /* @__PURE__ */ t(a, { length: 5 })
    ] });
  if (i === "form")
    return /* @__PURE__ */ n(o, { gap: 2, width: "100%", children: [
      /* @__PURE__ */ t(r, { variant: "text", width: 100, sx: { fontSize: "2rem" } }),
      /* @__PURE__ */ t(r, { variant: "text", width: 100, sx: { fontSize: "2rem" } })
    ] });
  if (i === "pointsgraph")
    return /* @__PURE__ */ t(o, { gap: 2, width: "100%", children: /* @__PURE__ */ t(r, { variant: "rectangular", width: "100%", height: 400 }) });
}, a = ({ length: i }) => /* @__PURE__ */ t(h, { spacing: 1, children: Array.from({ length: i }, (e, s) => /* @__PURE__ */ t(r, { sx: { flexGrow: "1" }, variant: "rounded", height: 50 }, s)) });
export {
  l as DaymapSkeleton
};
//# sourceMappingURL=index.js.map
